module.exports = __webpack_public_path__ + "static/Grupo 73-40d1c3fd29176978f03b6b29de6863d1.svg";